import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { Loader2, WifiOff } from "lucide-react";
import { TenantProvider, useTenant } from "../../contexts/TenantContext";
import TenantLanding from "./TenantLanding";
import TenantSectorGate from "./TenantSectorGate";
import TenantPrequalify from "./TenantPrequalify";
import TenantAuth from "./TenantAuth";
import TenantVerifyEmail from "./TenantVerifyEmail";
import TenantJourney from "./TenantJourney";
import RMLeads from "./rm/RMLeads";
import RMLeadDetail from "./rm/RMLeadDetail";
import { RMProvider, RMGate } from "../../components/tenant/rm/RMShell";

function Offline() {
  return (
    <div className="tenant-portal flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F7F8FA] px-6 text-center" data-testid="tenant-offline">
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-neutral-200 text-neutral-500"><WifiOff size={26} /></span>
      <h1 className="text-2xl font-extrabold text-neutral-800">This portal is offline</h1>
      <p className="max-w-sm text-sm text-neutral-500">The lending assessment portal you are trying to reach is not currently available. Please contact the institution directly, or visit <a className="font-semibold underline" href="https://clinq.africa">clinq.africa</a>.</p>
    </div>
  );
}

function TenantRoutes() {
  const { config, to } = useTenant();
  if (config === undefined) return <div className="flex min-h-screen items-center justify-center bg-[#F7F8FA]"><Loader2 className="h-6 w-6 animate-spin text-neutral-400" /></div>;
  if (config === null) return <Offline />;
  return (
    <Routes>
      <Route path="/" element={<TenantLanding />} />
      {config.partner_type === "ecosystem" && <Route path="/fit" element={<TenantSectorGate />} />}
      {config.prequal_flow && <Route path="/prequalify" element={<TenantPrequalify />} />}
      <Route path="/start" element={<TenantAuth />} />
      <Route path="/verify-email/:token" element={<TenantVerifyEmail />} />
      <Route path="/journey" element={<TenantJourney />} />
      <Route path="/rm" element={<RMProvider><RMGate><RMLeads /></RMGate></RMProvider>} />
      <Route path="/rm/leads/:id" element={<RMProvider><RMGate><RMLeadDetail /></RMGate></RMProvider>} />
      <Route path="*" element={<Navigate to={to("/")} replace />} />
    </Routes>
  );
}

export default function TenantApp({ sub, basePath }) {
  return (
    <TenantProvider sub={sub} basePath={basePath}>
      <TenantRoutes />
    </TenantProvider>
  );
}

export function TenantPathApp() {
  const { sub } = useParams();
  return <TenantApp key={sub} sub={sub} basePath={`/t/${sub}`} />;
}
